import { Request } from '../main'
import Link from 'next/link'

const request = new Request(process.env.apiDomain)

export default function BStartNav(props) {
    const site = props.site
    const {data: eo} = request.website.swrSite(site.accountId, "EO")

    return (
        <>
            <div className="take-tour">
                <div className="d-lg-block d-none">
                    <h5>Take the Tour!</h5>
                    <h6 className="mb-3"><small>Explore the opportunity <br className="d-lg-block d-none"/>
                        to work from anywhere.</small></h6>
                    <img src="/images/dashboard/img-take-the-tour01.svg" alt="Take the Tour!" className="d-block mx-auto mb-3" />
                    {eo ? <a href={'//' + eo.url + '/tour'} className="btn btn-blue rounded-pill text-white px-4"><strong>START</strong></a> : null}
                </div>
                <div className="d-lg-none d-block px-3">
                    {eo ? <Link href={ '//' + eo.url + '/tour'}><a className="d-flex align-items-center">
                        <img src="/images/dashboard/img-take-the-tour01.svg" alt="Take the Tour!" width={35} className="mr-2"/>
                        <div>
                            <h6 className="mb-0">TAKE THE TOUR!</h6>
                            <small>Explore the opportunity to work from anywhere.</small>
                        </div>
                    </a></Link> : null}
                </div>
            </div>
        </>
    )
}


